import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import type { BoxSelectProps } from "./BoxSelect";
import { BoxSelect } from "./BoxSelect";
import "./styles.scss";

export interface BoxProps extends BoxSelectProps {
  id: string;
  label?: string;
  name: string;
  variant: "box";
}

export interface SwitchProps extends ComponentPropsWithoutRef<"input"> {
  id: string;
  label?: string;
  name: string;
  variant: "switch";
}

const isBoxProps = (props: BoxProps | SwitchProps): props is BoxProps =>
  props.variant === "box";

export const Checkbox = (props: BoxProps | SwitchProps) => {
  const { register } = useFormContext();

  if (isBoxProps(props)) {
    return <BoxSelect {...props} />;
  }

  const { id, variant, name, label = t("checkbox"), ...rest } = props;

  const containerClassname = classNames("react-checkbox", {
    "simple-toggle": variant === "switch",
  });
  return (
    <div className={containerClassname}>
      <input {...rest} type="checkbox" id={id} {...register(name)} />
      <label htmlFor={id}>
        <span className="sr-only">{label}</span>
      </label>
    </div>
  );
};
